module.exports = __webpack_public_path__ + "download.svg";